export default {
    alert: {
        ready: `このページはただいま準備中です`
    },
    footer: {
        address: `CubePlatform, A-2009, URIM BLUE NINE BUSINESS CENTER, <br>583, Yangcheon-ro, Gangseo-gu, Seoul, 07547, Korea <br class="under-tablet-break">代表取締役 : 金 相佑（キム サンウ）`,
        copyright: `Copyright ⓒ 2020 All Rights Reserved by CubePlatform`
    },
    main: {
        visual: {
            desc01: `多国語を基盤とした<br>「グローバルECプラットフォーム<br>ソリューション」を提供`,
            desc02: `CubePlatform自社の<br>ソリューション<br>導入による安定した<br>グローバルネットワークを構築`,
            desc03: `優れたシステムと<br>最先端の装備の導入による<br>正確で素早い<br>フルフィルメントプラットフォーム`,
            desc04: `ECに特化した<br>多国語コンタクトセンター<br>サービスを提供`
        },
        about: {
            desc: `進化したECプラットフォーム<br>「CubePlatform」`
        },
        business: {
            desc: `CubePlatformは個人輸入, 越境ECに必要な<br class="under-tablet-break">進化したソリューションを提供します。`,
            section01: {
                desc: `国・言語・貨幣の垣根を越える<br>グローバルECプラットフォームを開発します。`
            },
            section02: {
                desc: `自社開発のシステムを<br>導入し、安定したグローバルネットワークを<br>構築しています。`
            },
            section03: {
                desc: `自社のフルフィルメントシステムを<br>導入し、安定したグローバルネットワークを<br>構築しています。`
            },
            section04: {
                desc: `海外にお住いのお客様の<br>商品のお問い合わせ、返品、返金などの<br>お困りごと全般を<br class="desktop-break">CubePlatformが代行します。`
            }
        },
        globalnetwork: {
            desc: `CubePlatformは<br>グローバルEC<br class="desktop-break">サービスの専門企業として<br>国を越え韓国、日本、<br>アメリカ、イギリス、ドイツに至る<br>グローバルネットワークを<br class="desktop-break">保有しています。`
        }
    },
    about: {
        title: `進歩したECプラットフォーム <br class="under-tablet-break">「CubePlatform」`,
        desc: `EC市場は日々、グローバル化しています。<br><br>CubePlatformは、国・言語・貨幣の垣根を越える<br class="under-tablet-break">グローバルECプラットフォーム・ソリューションを<br class="under-tablet-break">開発し、発展させていきます。<br class="under-tablet-break"><br class="under-tablet-break">世界のEC市場を完璧にまとめる<br class="under-tablet-break">ECプラットフォームの開発が<br class="under-tablet-break">CubePlatformの究極の目標です。`,
        section01: {
            title: `組織構成`,
            team01: {
                main: `ECプラットフォーム<br class="desktop-break">事業部`,
                sub01: `プラットフォーム企画チーム`,
                sub02: `プラットフォーム開発チーム`,
                sub03: `プラットフォームデザインチーム`
            },
            team02: {
                main: `ロジスティクス事業部`,
                sub01: `Cube企画チーム`,
                sub02: `Cube営業チーム`,
                sub03: ``
            },
            team03: {
                main: `コンタクトセンター`,
                sub01: `韓国語チーム`,
                sub02: `日本語チーム`,
                sub03: `英語チーム`
            }
        },
        section02: {
            desc01: `包装箱<br>(パッキングボックス)<br class="desktop-break">の象徴`,
            desc02: `EC<br class="under-tablet-break">プラットフォーム<br class="desktop-break">の象徴`
        },
        section03: {
            address: `CubePlatform, A-2009, URIM BLUE NINE BUSINESS CENTER, <br>583, Yangcheon-ro, Gangseo-gu, Seoul, 07547, Korea`
        }
    },
    business: {
        desc: `CubePlatformは<br>個人輸入・越境ECに最適な<br>ソリューションを提供します。<br>ソリューション・物流・<br class="desktop-break">コミュニケーションの悩みなく<br>グローバルマーケットへ<br class="desktop-break">進出することができます。`,
        section01: {
            sub01: {
                title: `EC<br class="under-tablet-break">プラットフォーム<br class="under-tablet-break">開発`,
                subTitle: `EC<br>プラットフォーム<br>開発`,
                desc: `<strong class="first">グローバルECプラットフォーム</strong><p>国・言語・貨幣の垣根を越える<br class="under-tablet-break">グローバルECプラットフォームを開発し、<br>個人輸入・越境ECに必要な<br class="under-tablet-break">WEB・モバイルソリューションを<br class="under-tablet-break">会員社へ供給します。<br>会員社がソーシング、マーケティングの<br class="under-tablet-break">みに集中できるよう全力でサポートします。</p><strong>EC物流プラットフォーム</strong><p>ECに特化した物流プラットフォームにより、<br class="under-tablet-break">在庫管理、入荷・出荷機能はもちろん、<br>世界の主なECソリューションとの<br class="under-tablet-break">在庫や注文データの同期化も可能です。<br></p>`,
                linkTitle: ``,
                link: ``
            },
            sub02: {
                title: `グローバルEC<br class="under-tablet-break">物流サービス`,
                subTitle: `グローバルEC<br>物流サービス`,
                desc: `<p>CubePlatformは自社開発のシステムを導入し、<br>安定したグローバルネットワークを<br class="under-tablet-break">構築しています。<br>会員社は海外に進出しなくても、<br>効率的な物流サービスをご利用いただけます。</p>`,
                linkTitle: ``,
                link: ``
            },
            sub03: {
                title: `グローバルフル<br class="under-tablet-break">フィルメント<br class="under-tablet-break">(3PL)サービス`,
                subTitle: `グローバルフル<br>フィルメント<br>(3PL)サービス`,
                desc: `<p>自社のフルフィルメントシステムを導入し、<br class="under-tablet-break">安定したグローバルネットワークを<br class="under-tablet-break">構築しています。<br />在庫管理による<br class="under-tablet-break">フルフィルメントサービスに限らず、<br class="under-tablet-break">在庫を持たない商品の<br class="under-tablet-break">配送代行サービスも提供できます。<br />会員社は海外進出という手間が省け、<br class="under-tablet-break">効率の高い物流サービスをご利用いただけます。</p>`,
                linkTitle: `LOGISBIZへ移動`,
                link: `http://logisbiz.co.kr/`
            },
            sub04: {
                title: `多国語コンタクト<br class="under-tablet-break">センターのサービス`,
                subTitle: `多国語コンタクト<br>センターの<br>サービス`,
                desc: `<p>海外にお住いのお客様の商品の<br class="under-tablet-break">お問い合わせ、返品、返金などのお困りごと全般を<br class="under-tablet-break">CubePlatformが代行します。<br><br>コンタクトセンター : <br class="under-tablet-break">韓国語・日本語・英語</p>`,
                linkTitle: ``,
                link: ``
            }
        }
    },
    globalnetwork: {
        title: `革新的なグローバルECサービスの中心、<br class="under-tablet-break">CUBE PLATFORM`,
        desc: `CubePlatformは韓国をかわきりに、日本、ドイツにおける<br class="under-tablet-break">グローバルネットワークを構築しており、<br class="under-tablet-break">世界中の誰もが自由に利用できる<br>グローバルECサービスを提供するため、<br class="under-tablet-break">より多くの市場への進出を目前に控えています。`,
        section01: {
            center01: {
                title: `韓国ソウル(SEOUL)センター`,
                desc: `서울시 강서구 양천로 583 <br class="under-tablet-break">우림블루나인비즈니스센터 A-2009호`
            },
            center02: {
                title: `日本東京(TOKYO)センター`,
                desc: `千葉県船橋市南海神1-7-4 船橋FLC 4階, TOKYO, JAPAN`
            },
            center03: {
                title: `ドイツフランクフルト(FRA)センター`,
                desc: `PHILIPP-REIS-STARßE 363486 BRUCHKÖBEL`
            },
            center04: {
                title: `イギリス(UK)センター`,
                desc: `DC4, IMPERIAL ROAD, RYTON ON DUNSMORE, COVENTRY, <br class="under-tablet-break">CV8 3LF, UNITED KINGDOM`
            }
        }

    },
    recruit: {
        desc01: `常識に基づいて発展する <br class="desktop-break">CubePlatformです。`,
        desc02: `CubePlatformは韓国の<span>勤労基準法を遵守</span>します。<br>CubePlatformは<span>定時退社を厳守</span>します。<br>CubePlatformはグローバル企業として<br class="under-tablet-break"><span>素早く躍進</span>し続けています。<br>CubePlatformは実績No.1のみならず、<br class="under-tablet-break"><span>福利厚生No.1</span>を目指します。<br>CubePlatformには<br class="under-tablet-break"><span>パワーハラスメントや差別がありません。</span>`,
        section01: {
            title: `CubePlatformの福利厚生`,
            desc1: `１年1回 <br/>韓日往復航空券の提供`,
            desc2: `敷金1,000万ウォン<br/>無利息の貸付`,
            desc3: `お誕生日には午前勤務のみ<br/>＋プレゼント`,
            desc4: `1年に1回人間ドックの提供<br/><span>（本人または家族）</span>`,
            desc5: `引越し費用<br>支援`,
            desc6: `社内のショッピング<br>ポイント付与<br><span>(個人輸入向け)</span>`,
            desc7: `チーム別文化活動費<br class="desktop-break">補助`,
            desc8: `書籍購入費<br class="desktop-break">補助`,
            desc9: `自己啓発の費用<br class="desktop-break">補助`,
            desc10: `社内カフェ<br class="desktop-break">運営`,
            desc11: `日本・韓国の<br class="desktop-break">お菓子の提供`,
            desc12: `デュエルモニター＋<br>macOSまたは<br>Windowのうち、いずれか一方`
        },
        section02: {
            title: `採用情報`,
            modal: {
                title: `募集職種`,
                desc: `CubePlatformと共にグローバルサービスを<br class="under-tablet-break">創り上げていくチャレンジ精神に<br class="under-tablet-break">満ち溢れた人材を求めます。`,
                category01: `プラットフォーム<br class="under-tablet-break">開発`,
                category02: `プラットホーム<br class="under-tablet-break">デザイン`,
                category03: `ロジスティクス<br class="under-tablet-break">事業部`,
                category04: `コンタクト<br class="under-tablet-break">センター`,
                site01: `JOB KOREA 応募`,
                site02: `SARAM IN 応募`
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/translations/locales/jp.js